<template>
  <a-upload
    :multiple="true"
    :file-list="fileList"
    @change="handleChange"
    :customRequest="req"
    list-type="picture-card"
    :show-upload-list="false"
    :before-upload="beforeUpload"
  >
    <img v-if="imageUrl" :src="imageUrl" height="90" alt="avatar" class="object-cover w-full" :class="hasRoundedImg ? 'img-avatar' : ''"/>
    <div v-else>
      <a-icon :type="loading ? 'loading' : 'plus'" />
      <div class="ant-upload-text">
        Upload
      </div>
    </div>
  </a-upload>
</template>
<script>
  import axios from "@/axios";
  export default {
    props: {
          url     : { type : String  },
          st      : { type : String  },
          rows    : { type : Object , default: ()=>{} },
          hasRoundedImg : { type : Boolean , default: true },
    },
    data() {
      return {
        fileList: [],
        imageUrl:'',
        loading: false
      };
    },
    methods: {
      handleChange(info) {
        let fileList = [...info.fileList];

        fileList = fileList.slice(-1);

        fileList = fileList.map(file => {
          if (file.response) {
            file.url = file.response.url;
          }
          return file;
        });

        this.fileList = fileList;
      },
      async req(input) {
        try {
          this.loading = true;
          let formData = new FormData();
          formData.append("file", input.file);
          if(this.imageUrl) this.imageUrl = ''
          const {data} = await axios.post(this.url,formData, {'Content-Type': 'multipart/form-data'});
          this.imageUrl = data.url || data.firm_avatar_url
          this.$emit('input', data.url || data.firm_avatar_url);
          this.$emit('change', data);
        } catch (e) {
          this.$message.error('Error receiving data');
        } finally {
          this.loading = false;
        }
      },
      beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
          this.$message.error('You can only upload JPG or PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isLt2M) {
          this.$message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
      },
      showImageProfile(){
        this.imageUrl = `${this.rows.avatar_url}?st=${this.st}`
      }
    },
  };
</script>


<style>
  .img-avatar{
    border-radius: 50%;
  }
</style>
